const 	$ = jQuery,
		$readMoreItems = $('.js-read-more'),
		$readMorebuttons = null;

if ( $readMoreItems.length ) {

	$readMoreItems.each( function () { 

		let $currentItem = $(this),
			readLessText = $currentItem.data('read-less') ? $currentItem.data('read-less') : 'Read Less';

		$currentItem.after( '<button class="cta cta--simple read-more-button js-read-more-button fs-xs">' + readLessText + '</button>' );

		$currentItem.addClass('is-open');

	})

	$readMoreButtons = $('.js-read-more-button');

	$readMoreButtons.on('click', function () {

		toggleExtendedText( 400, $(this) );

	})

	function toggleExtendedText ( slideDuration, clickedElement ) {

		let $targetExtendedText = clickedElement.prev();

		$targetExtendedText.slideToggle( slideDuration );

		$targetExtendedText.toggleClass('is-open');

		clickedElement.html( getButtonText( $targetExtendedText ) );

	}

	function getButtonText ( targetElement ) {

		if ( targetElement.hasClass('is-open') ) {

			return targetElement.data('read-less') ? targetElement.data('read-less') : 'Read Less';

		} else {

			return targetElement.data('read-more') ? targetElement.data('read-more') : 'Read more';

		}

	}

	$readMoreButtons.each( function () {

		toggleExtendedText( 0, $(this) );

	})

}